var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/outlined/chevron_double_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93934 8.93934C9.52513 8.35355 10.4749 8.35355 11.0607 8.93934L24 21.8787L36.9393 8.93934C37.5251 8.35355 38.4749 8.35355 39.0607 8.93934C39.6464 9.52513 39.6464 10.4749 39.0607 11.0607L25.0607 25.0607C24.7794 25.342 24.3978 25.5 24 25.5C23.6022 25.5 23.2206 25.342 22.9393 25.0607L8.93934 11.0607C8.35355 10.4749 8.35355 9.52513 8.93934 8.93934ZM8.93934 24.9393C9.52513 24.3536 10.4749 24.3536 11.0607 24.9393L24 37.8787L36.9393 24.9393C37.5251 24.3536 38.4749 24.3536 39.0607 24.9393C39.6464 25.5251 39.6464 26.4749 39.0607 27.0607L25.0607 41.0607C24.4749 41.6464 23.5251 41.6464 22.9393 41.0607L8.93934 27.0607C8.35355 26.4749 8.35355 25.5251 8.93934 24.9393Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionScroll);
export default __webpack_public_path__ + "static/media/direction_scroll.047cc64c3c120097896b6357c6819141.svg";
export { ForwardRef as ReactComponent };